import React from 'react';
import { ChakraProvider, Box, Flex } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import theme from './theme/Index';  // Updated path to correctly point to theme/Index.js

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

// Individual Project Pages
import EspBoardpulse from './pages/projects/EspBoardpulse';
import SplMeter from './pages/projects/SplMeter';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <ScrollToTop /> {/* Add ScrollToTop component here */}
        <Flex 
          direction="column" 
          minH="100vh" // Ensure minimum height is full viewport
        >
          <Header />
          <Box flex="1"> {/* This will take up all available space, pushing footer down */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/esp-boardpulse" element={<EspBoardpulse />} />
              <Route path="/projects/spl-meter" element={<SplMeter />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          <Footer />
        </Flex>
      </Router>
    </ChakraProvider>
  );
}

export default App;






